import { createNamespace } from '../utils';

var _createNamespace = createNamespace('bank-card'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

var bankType = {
  ABC: '中国农业银行',
  BJBANK: '北京银行',
  BOC: '中国银行',
  CCB: '中国建设银行',
  CEB: '中国光大银行',
  CIB: '兴业银行',
  CITIC: '中信银行',
  CMB: '招商银行',
  CMBC: '中国民生银行',
  COMM: '交通银行',
  GDB: '广东发展银行',
  HXBANK: '华夏银行',
  ICBC: '中国工商银行',
  NBBANK: '宁波银行',
  PSBC: '中国邮政储蓄银行',
  SHBANK: '上海银行',
  SPABANK: '平安银行',
  SPDB: '上海浦东发展银行'
};
var cardType = {
  DC: '储蓄卡',
  CC: '信用卡'
};
export default createComponent({
  props: {
    name: String,
    type: {
      type: String,
      default: 'DC'
    },
    number: String,
    showLength: {
      type: Number,
      default: 4
    }
  },
  render: function render() {
    var h = arguments[0];
    var name = this.name,
        number = this.number,
        type = this.type,
        showLength = this.showLength;
    var showNumber = number.slice(-showLength);
    return h("div", {
      "class": bem([name])
    }, [h("div", {
      "class": bem('name')
    }, [bankType[name] || name]), h("div", {
      "class": bem('type')
    }, [cardType[type] || type]), h("div", {
      "class": bem('number')
    }, [h("span", {
      "class": bem('encrypt-number')
    }, ["****"]), h("span", {
      "class": bem('encrypt-number')
    }, ["****"]), h("span", {
      "class": bem('encrypt-number')
    }, ["****"]), h("span", [showNumber])])]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/bank-card/index.js
// module id = null
// module chunks = 